import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';

import { forkJoin, from } from 'rxjs';

import { BaasAppState, BaasConfigurationService } from '@lvflanders/bar';

import { StartschermV2StateService } from '../../services/v2/startscherm-v2-state.service';

type Omgeving = {
    omgeving: string;
    url: string;
};

@Component({
    selector: 'startscherm-omgevingen',
    templateUrl: './startscherm-omgevingen-widget.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StartschermOmgevingen implements OnInit {
    readonly #profiel = inject(BaasConfigurationService);
    readonly #core = inject(BaasAppState);
    readonly #state = inject(StartschermV2StateService);

    protected readonly omgevingen = signal<Omgeving[]>([]);
    protected currentOmgeving = this.#core.toepassing.omgeving;
    protected isVisible = this.#state.isIntern;

    ngOnInit(): void {
        console.log('Omgevingspicker current omgeving: ', this.currentOmgeving);
        forkJoin({
            DEV: from(this.#profiel.readValue({ appCode: 'STABUI', pathAndKey: 'Startscherm\\OmgevingUrls\\StaUrlDEV' })),
            TST: from(this.#profiel.readValue({ appCode: 'STABUI', pathAndKey: 'Startscherm\\OmgevingUrls\\StaUrlTST' })),
            PRD: from(this.#profiel.readValue({ appCode: 'STABUI', pathAndKey: 'Startscherm\\OmgevingUrls\\StaUrlPRD' }))
        }).subscribe((res) => {
            if (res) {
                console.log('resultaat ophalen profielkeys profiel.read ', res);

                const omgevingen: Omgeving[] = [];
                Object.entries(res).forEach(([key, value]) => {
                    omgevingen.push({ omgeving: key, url: value });
                });
                this.omgevingen.set(omgevingen);
                console.log('omgevingen bevat: ', this.omgevingen());
            }
        });
    }
}
